import React from "react";
import ReactPlayer from 'react-player';
import KanziFadeTitle from './KanziFadeTitle';
import './KanziCelebration.css';

const KanziCelebration = () => {

  return (
    <>
      <h1>Celebrating the Life of ...</h1>
      <div className="Kanzi-header">
        <div className="Kanzi-header-container">
          <img
            src="KanziHeadshot.png"
            alt="Kanzi looks to the right"
          />
        </div>
        <div className="Kanzi-header-container">
          <KanziFadeTitle />
        </div>
      </div>
      <div className="Kanzi-video-block">
        <div>
          <p>Hightlights of Kanzi's <br />
             amazing <br />
             linguistic understanding <br />
             and life <br />
             <br />
             Watch for those happy smiles!</p>
        </div>
        <div className="video-container">
          <ReactPlayer
            url="https://bhivideos.s3.us-east-2.amazonaws.com/KanziMemories1a.mp4"
            playing={true}
            loop={true}
            muted={true}
            controls
            width="auto"
            height="auto"
          />
        </div>
      </div>
    </>
  )
};

export default KanziCelebration;